var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99265 6.22941L9.80945 9.93821C9.92705 10.0022 10.0726 10.0022 10.191 9.93821L17.0079 6.22941C17.2823 6.07981 17.2583 5.69741 16.9663 5.57981L10.1502 2.8286C10.0542 2.7902 9.94545 2.7902 9.84945 2.8286L3.03345 5.57981C2.74225 5.69741 2.71825 6.07981 2.99265 6.22941ZM16.9664 8.92477L15.5024 8.30077L10.1912 11.1904C10.0728 11.2544 9.9272 11.2544 9.8088 11.1904L4.4976 8.30077L3.0336 8.92477C2.7416 9.04877 2.7176 9.45357 2.9928 9.61117L9.8088 13.5288C9.9272 13.5968 10.0728 13.5968 10.1912 13.5288L17.0072 9.61117C17.2824 9.45357 17.2584 9.04877 16.9664 8.92477ZM15.7208 11.9379L16.9664 12.4771C17.2584 12.6035 17.2824 13.0139 17.0072 13.1739L10.1912 17.1483C10.0728 17.2171 9.9272 17.2171 9.8088 17.1483L2.9928 13.1739C2.7176 13.0139 2.7416 12.6035 3.0336 12.4771L4.2792 11.9379L9.8088 14.9467C9.9272 15.0107 10.0728 15.0107 10.1912 14.9467L15.7208 11.9379Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductMenu);
export default __webpack_public_path__ + "static/media/product-menu.f3afd3ddecdc2a147a3bc340c3c8a265.svg";
export { ForwardRef as ReactComponent };